import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { AccountType } from '../../../../generated/generated-types';

export function bankAccountLinkFallbackFields(): FormlyFieldConfig[] {
    return [
        {

            fieldGroupClassName: 'flex flex-wrap',
            props: {
                label: _("bank-account-link.edit"),
                translate: true
            },
            fieldGroup: [
                {
                    className: "w-full",
                    fieldGroupClassName: "column",
                    fieldGroup: [
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'bankAccount.bank',
                                    className: "w-full",
                                    type: 'formly-bank-list-dropdown',
                                    props: {
                                        label: _('bank-account.bank'),
                                        translate: true
                                    },
                                }]
                        },
                        {
                            className: "w-full",
                            fieldGroupClassName: "flex flex-wrap",
                            fieldGroup: [
                                {
                                    key: 'bankAccount.description',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank-account.description'),
                                        translate: true,
                                    }
                                },
                                {
                                    key: 'isDefault',
                                    type: 'checkbox',
                                    className: "w-full md:w-1/2 mt-6",
                                    props: {
                                        label: _('bank-account.is-default-account'),
                                        translate: true,
                                        required: false,
                                        indeterminate: false,
                                        attributes: {
                                            'data-testid': "formly-bank-account-is-default-account"
                                        }
                                    },
                                },

                                {
                                    key: 'bankAccount.accountHolder',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank-account.account-holder'),
                                        translate: true
                                    },
                                },
                                {
                                    key: 'bankAccount.accountType',
                                    className: "w-full md:w-1/2",
                                    type: 'formly-generic-enum-drop-down',
                                    props: {
                                        label: _('bank-account.account-type'),
                                        translate: true,
                                        attributes: {
                                            enumName: "AccountType"
                                        }
                                    },
                                },
                                {
                                    key: 'bankAccount.iban',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank-account.iban'),
                                        translate: true,
                                    },
                                    expressionProperties: {
                                        'templateOptions.disabled': (formState: any) => formState.accountType === AccountType.CASH,
                                    },

                                },
                                {
                                    key: 'bankAccount.currency',
                                    className: "w-full md:w-1/2",
                                    type: 'formly-generic-enum-drop-down',
                                    props: {
                                        label: _('bank-account.currency'),
                                        translate: true,
                                        attributes: {
                                            enumName: "CurrencyCode"
                                        }
                                    },
                                },
                                // {
                                //     key: 'accountNumber',
                                //     className: "w-full md:w-1/2",
                                //     wrappers: ["simple-title"],
                                //     type: 'input',
                                //     props: {
                                //         label: _('bank-account.account-number'),
                                //         translate: true
                                //     },
                                //     expressionProperties: {
                                //         'templateOptions.disabled': (formState: any) => formState.accountType === AccountType.CASH,
                                //     },
                                // },
                                {
                                    key: 'bankAccount.bookingAccount',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank-account.booking-account'),
                                        translate: true
                                    },
                                },
                                {
                                    key: 'bankAccount.feeAccount',
                                    className: "w-full md:w-1/2",
                                    wrappers: ["simple-title"],
                                    type: 'input',
                                    props: {
                                        label: _('bank-account.fee-account'),
                                        translate: true
                                    },
                                },
                            ],
                        },
                    ]
                },
            ]
        },
    ]
}




